module.exports = __webpack_public_path__ + "img/dugout-lounge-tables-02.add836e1.jpeg";